import React, { useState, useRef } from 'react';
import { Captcha, CaptchaHandle } from '../../components/Captcha';
const PROGRAM_OPTIONS = ['Family Classes', 'Kids Taekwondo', 'Adult Classes', 'General Question'];
interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
}
function Field({
  id,
  label,
  ...rest
}: FieldProps) {
  return <div data-id="element-1110">
      <label htmlFor={id} className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1111">
        {label}
      </label>
      <input id={id} name={id} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" {...rest} data-id="element-1112" />
    </div>;
}
export function FamilyLeadForm() {
  const [captchaValid, setCaptchaValid] = useState(false);
  const captchaRef = useRef<CaptchaHandle>(null);
  const handleSubmit = (e: React.FormEvent) => {
    if (!captchaRef.current?.isValid()) {
      e.preventDefault();
    }
  };
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-1113">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-1114">
        Find a Family Class
      </div>

      <form action="/thank-you-free-trial" method="get" onSubmit={handleSubmit} className="mt-4 flex flex-col gap-5" data-id="element-1115">
        <Field id="parentName" label="Parent / Guardian Name" type="text" required autoComplete="name" placeholder="Parent or Guardian Name" data-id="element-1116" />
        <Field id="phone" label="Phone Number" type="tel" required autoComplete="tel" placeholder="(517) 220-0621" data-id="element-1117" />
        <Field id="email" label="Email Address" type="email" required autoComplete="email" placeholder="email@example.com" data-id="element-1118" />

        <div className="grid grid-cols-2 gap-4" data-id="element-1119">
          <Field id="familyMembers" label="Family Members" type="number" inputMode="numeric" min={1} placeholder="e.g. 3" required data-id="element-1120" />
          <Field id="childAges" label="Child Ages" type="text" placeholder="e.g. 7, 10" data-id="element-1121" />
        </div>

        <div data-id="element-1122">
          <label htmlFor="interestedIn" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1123">
            Interested In
          </label>
          <select id="interestedIn" name="interestedIn" required defaultValue="Family Classes" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-1124">
            {PROGRAM_OPTIONS.map(opt => <option key={opt} value={opt} data-id="element-1125">
                {opt}
              </option>)}
          </select>
        </div>

        <Captcha ref={captchaRef} onValidChange={setCaptchaValid} data-id="element-1126" />

        <button type="submit" disabled={!captchaValid} className="btn-primary w-full disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1127">
          Check Family Availability
        </button>

        <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-1128">
          We will help you choose a family class time that works for everyone
          before your first visit.
        </p>
      </form>
    </div>;
}